// @flow

import queryString from 'query-string';
import { get } from 'lodash';

import { addTruthyParamsToUrl, isBrowser } from '@zapier/common-utils';

import { APPS_PAGES_MOUNT_POINT } from 'web-ssr/app/common/constants';

import type { AppActionDropdownItem } from '@zapier/design-system-app-profiles';

export const createAbsoluteURL = (path: string) => `https://zapier.com${path}`;

export const createAppDirectoryLink = (url: string) =>
  `/${APPS_PAGES_MOUNT_POINT}/${url}`;

export const createAppOverviewPageLink = (appSlug: string) =>
  createAppDirectoryLink(`${appSlug}`);

export const createAppIntegrationsPageLink = (appSlug: string) =>
  createAppDirectoryLink(`${appSlug}/integrations`);

export const createAppAlternativesPageLink = (appSlug: string) =>
  createAppDirectoryLink(`${appSlug}/alternatives`);

export const createAppHelpPageLink = (appSlug: string) =>
  createAppDirectoryLink(`${appSlug}/help`);

export const createAppTutorialsPageLink = (appSlug: string) =>
  createAppDirectoryLink(`${appSlug}/tutorials`);

export const createAppTutorialDetailsLink = (
  appSlug: string,
  tutorialSlug: string
) => createAppDirectoryLink(`${appSlug}/tutorials/${tutorialSlug}`);

export const createTwoAppPageLink = (
  primaryAppSlug: string,
  secondaryAppSlug: string
) =>
  createAppDirectoryLink(`${primaryAppSlug}/integrations/${secondaryAppSlug}`);

export const createZapTemplatePageLink = (
  primaryServiceSlug: string,
  secondaryServiceSlug: string,
  zapId: string,
  zapSlug: string
) =>
  `${createTwoAppPageLink(
    primaryServiceSlug,
    secondaryServiceSlug
  )}/${zapId}/${zapSlug}`;

export const buildMakeAZapLink = (
  selectedTrigger: AppActionDropdownItem,
  selectedAction: AppActionDropdownItem
) => {
  const qs = queryString.stringify({
    template__0__selected_api: get(selectedTrigger, ['appId']),
    template__0__type_of: get(selectedTrigger, ['typeOf']),
    template__0__action: get(selectedTrigger, ['value']),
    template__1__selected_api: get(selectedAction, ['appId']),
    template__1__type_of: get(selectedAction, ['typeOf']),
    template__1__action: get(selectedAction, ['value']),
    create: true,
  });

  return `/app/editor/?${qs}`;
};

export const createOneAppEditorLink = (
  primaryAppImplementationId: string
): string => `/zapbook/create/${primaryAppImplementationId}`;

export const createTwoAppEditorLink = (
  primaryAppImplementationId: string,
  secondaryAppImplementationId: string
): string =>
  `/zapbook/create/${primaryAppImplementationId}/${secondaryAppImplementationId}`;

export const buildSignUpUrl = (options: {
  next?: string,
  serviceIds?: Array<string>,
}) => {
  const referrer =
    isBrowser() && queryString.parse(window.location.search).referrer;

  return addTruthyParamsToUrl('/sign-up/', {
    next: options.next,
    selected_apis: (options.serviceIds || []).join(','),
    referrer,
  });
};
